import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks';
import VisuallyHidden from '@wix/da-shared-react/pkg/a11y/VisuallyHidden';
import FacetPage from '../FacetPage';
import PageContainer from '../PageContainer';
import ContentLoader from '../ContentLoader';
import BrowseThumbLayout from '../BrowseThumbLayout';
import SearchPageHeader from './_partials/SearchPageHeader';
import { FacetPageType } from '../../../types/api';

export interface Props {
  pageType: FacetPageType;
}

const SearchPage: React.FC<Props> = ({ pageType }) => {
  const { t } = useTranslation();
  const shouldRenderH1 = useFlag('proposed_h1s');
  return (
    <>
      {shouldRenderH1 && (
        <VisuallyHidden>
          <h1>{t('searchPage.heading')}</h1>
        </VisuallyHidden>
      )}
      <PageContainer isSearchPage withNetworkBar={false}>
        <FacetPage>
          <ContentLoader>
            {pageType === 'search_home' && <SearchPageHeader />}
            <BrowseThumbLayout />
          </ContentLoader>
        </FacetPage>
      </PageContainer>
    </>
  );
};
SearchPage.displayName = 'SearchPage';

export default SearchPage;
